import React from "react";

import { env } from "@/config/environment-vars";
import { AuthProvider } from "@/contexts/auth";
import "@/config/i18n.config";
import { Toaster } from "@cmde/shadcn";
import { Helmet } from "react-helmet-async";
import { AppHelmetProvider } from "./helmet-provider";
import PersistQueryProvider from "./persist-query-provider";
import { ThemeProvider } from "./theme-provider";

const Providers = ({ children }: { children: React.ReactNode }) => {
  return (
    <AppHelmetProvider>
      <Helmet>
        <title>{env.VITE_PROJECT_TITLE}</title>
      </Helmet>
      <ThemeProvider defaultTheme="dark" storageKey={env.VITE_THEME_KEY || "theme"}>
        <PersistQueryProvider>
          <AuthProvider>
            {children}
            <Toaster position="top-right" />
          </AuthProvider>
        </PersistQueryProvider>
      </ThemeProvider>
    </AppHelmetProvider>
  );
};

export default Providers;
